import {getHostPhone} from './api'
import {Platform} from "react-native";
import { JDNativeSystem } from '@jdreact/jdreact-core-lib'
/**
 * 当400接口无返回或返回错误，使用现有拨号功能进行拨打（400大号+分机号）。
 * @param extensionNum 分机号
 * @param extensionPhone 主机号
 * @param phoneNum 手机号
 */
const getCommonPhone= (phoneInfo) => {
	let extensionPhone = phoneInfo.extensionPhone ? phoneInfo.extensionPhone : ''; // 经纪分机电话号码
	let extensionNum = phoneInfo.extensionNum ? ',' + phoneInfo.extensionNum : ''; // 经纪人分机号
	let phoneNum = phoneInfo.phoneNum ? phoneInfo.phoneNum : phoneInfo; // 经纪人电话
	let currentTel = '';
	if (extensionPhone && extensionNum) {
		currentTel = extensionPhone + extensionNum;
	} else if (extensionPhone && !extensionNum) {
		currentTel = extensionPhone;
	} else {
		currentTel = phoneNum;
	}
	return currentTel;
};

const toCallPhone = (phoneNumber) => {
	if (Platform.OS === 'web') {
		window.location.href = "tel:" + phoneNumber;
	} else {
		JDNativeSystem.callPhone('' + phoneNumber);
	}
};

function callPhone(phoneInfo) { // 获取最终拨打的电话
	let {extensionNum, extensionPhone} = phoneInfo; // extensionPhone: 分机号；extensionPhone: 主机号
	extensionPhone && (extensionPhone = extensionPhone.replace(/-/g, ""));
	if (extensionPhone == "4006015618") { // 大号是4006015618，才走400系统接口
		getHostPhone(extensionNum).then(res => {
			return res.json();
		}).then(res => {
			if (res.code && res.code == 1) {
				toCallPhone(res.data);
			} else {
				toCallPhone(getCommonPhone(phoneInfo));
			}
		}).catch(err => {
			toCallPhone(getCommonPhone(phoneInfo));
			console.log(err,"query host phone err");
		});
	} else {
		toCallPhone(getCommonPhone(phoneInfo));
	}
}

function zufangCall(extensionNum, telPhone) { 
	if (extensionNum) {
		getHostPhone(extensionNum).then(res => {
			return res.json();
		}).then(res => {
			if (res.code && res.code == 1) {
				toCallPhone(res.data);
			} else {
				toCallPhone(telPhone);
			}
		}).catch(err => {
			toCallPhone(telPhone);
			console.log(err,"query host phone err");
		});
	} else {
		toCallPhone(telPhone);
	}
}

export { toCallPhone, callPhone, zufangCall }
